import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_IMAGE, heroGuarantees } from '../../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-seyes" data-id="element-275" data-mp="3lugnb4t0m8fn">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-276" data-mp="3qokxdwxkuwky" />
      <div className="relative mx-auto max-w-6xl px-8 pb-16 pt-4 sm:px-14 sm:pb-20 sm:pt-6 lg:pb-28" data-id="element-277" data-mp="3uqzfgetf9sb6">
        <div className="mt-4 flex flex-col sm:mt-12 lg:mt-16 lg:grid lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-12" data-id="element-278" data-mp="3k549o5077gd">
          <div className="contents lg:block" data-id="element-279" data-mp="dh1dxx6n1zmi">
            <motion.h1 initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE
          }} className="order-1 text-center font-serif text-[2.15rem] leading-none sm:leading-[0.95] lg:text-left tracking-tight text-slate-900 sm:text-6xl lg:text-[4rem]" data-id="element-280" data-mp="dfqajyh3utvx">
              Get{' '}
              <span className="relative inline-block whitespace-nowrap" data-id="element-281" data-mp="3fogawa0vasfu">
                <motion.span aria-hidden="true" initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.3,
                delay: 0.25,
                ease: EASE
              }} className="absolute inset-x-[-0.08em] bottom-[0.08em] top-[0.38em] -z-0 origin-left -rotate-1 rounded-[0.12em] bg-amber-300/80" data-id="element-282" data-mp="3au2a1s3frt3s" />
                <span className="relative" data-id="element-283" data-mp="2esb2suuf408">a whole season</span>
              </span>{' '}
              of rugby sessions ready to coach in just{' '}
              <span className="relative inline-block whitespace-nowrap italic text-red-700" data-id="element-284" data-mp="3tkbmrvwun39q">
                5 minutes
                <svg aria-hidden="true" viewBox="0 0 200 14" preserveAspectRatio="none" className="absolute -bottom-1.5 left-0 h-3 w-full sm:-bottom-2.5" data-id="element-285" data-mp="3klq666axtybl">
                  <motion.path d="M3 9 C 45 3, 95 2, 135 6 S 185 11, 197 4" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" vectorEffect="non-scaling-stroke" initial={{
                  pathLength: 0
                }} animate={{
                  pathLength: 1
                }} transition={{
                  duration: 0.3,
                  delay: 0.35,
                  ease: EASE
                }} data-id="element-286" data-mp="2d97nwi55eif5" />
                </svg>
              </span>
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.08,
            ease: EASE
          }} className="order-3 mx-auto mt-4 max-w-xl text-center text-[15px] lg:mx-0 lg:text-left leading-snug text-slate-900/75 sm:mt-8 sm:text-xl sm:leading-relaxed" data-id="element-287" data-mp="20q29qng4eo9h">
              Stop improvising at training. Six digital volumes for youth, school and club rugby coaches: a full season plan, session cards, attack, defence, set piece and kicking systems – plus five bonuses.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.16,
            ease: EASE
          }} className="order-4 mt-5 sm:mt-8 lg:mt-10" data-id="element-288" data-mp="1mydwuhy1rvrg">
              <div className="flex justify-center lg:justify-start" data-id="element-289" data-mp="1cyep2n9gc9fn"><CtaButton href="#offer-card" className="w-full sm:w-auto" data-id="element-290" data-mp="ube9llxs8k44" /></div>
              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-xs text-slate-900/70 sm:mt-6 sm:gap-x-6 sm:text-sm lg:justify-start" data-id="element-291" data-mp="udibxzg19b2a">
                {heroGuarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-292" data-mp="13dds6iog3w96"><CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-293" data-mp="ychmq0og421n" />{item}</li>)}
              </ul>
            </motion.div>
          </div>
          <motion.figure initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.12,
          ease: EASE
        }} className="relative order-2 mx-auto mt-4 w-full max-w-md sm:mt-12 sm:pt-10 lg:mt-0" data-id="element-294" data-mp="1d8fi3gqjp2ct">
            <div aria-hidden="true" className="absolute right-0 top-0 z-10 hidden -rotate-3 items-end gap-1 sm:flex" data-id="element-295" data-mp="1i18gznzc1ggz">
              <svg viewBox="0 0 60 50" className="h-10 w-12 text-red-700" fill="none" data-id="element-296" data-mp="1vzye33m5jg5c"><path d="M56 6 C 40 4, 18 12, 10 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-297" data-mp="1r1wywtruk0z5" /><path d="M4 32 L10 42 L18 34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-298" data-mp="2b3rl2txjcqhj" /></svg>
              <span className="font-serif text-xl italic leading-tight text-red-700" data-id="element-299" data-mp="2f4bf3omtbdzg">6 volumes<br data-id="element-300" data-mp="2jvl3klwmkb9r" />+ 5 bonuses</span>
            </div>
            <img src={PRODUCT_IMAGE} alt="RUGBY READY box set: six rugby coaching volumes – season plan, attack, defence, set piece, kicking and the elite edge" className="relative mx-auto h-64 w-auto drop-shadow-xl sm:h-auto sm:w-full" data-id="element-301" data-mp="2jy67dgghh1a5" />
          </motion.figure>
        </div>
      </div>
    </section>;
}